import { render, staticRenderFns } from "./SurveyCompletedDialog.vue?vue&type=template&id=cb671eac&scoped=true&"
import script from "./SurveyCompletedDialog.vue?vue&type=script&lang=ts&"
export * from "./SurveyCompletedDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyCompletedDialog.vue?vue&type=style&index=0&id=cb671eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb671eac",
  null
  
)

export default component.exports